var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/icon/icon.tsx";
const _excluded = ["src", "alt", "count", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Counter from '../counter/counter';
import SvgIcon from './svg-icon';
/** Renders and SVG icon with optional counter. */
const Icon = _ref => {
  let {
      src,
      alt,
      count,
      size
    } = _ref,
    filteredProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative",
    "data-testid": "icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 3
    }
  }, count ? /*#__PURE__*/React.createElement("span", {
    className: "absolute -top-2 -right-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Counter, {
    count: count,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  })) : null, /*#__PURE__*/React.createElement(SvgIcon, _extends({
    src: src,
    size: size,
    alt: alt
  }, filteredProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  })));
};
export default Icon;